import { useDispatch, useSelector } from "react-redux";
import { setMainLoading } from "../Store/reducers/Common";
import { useState } from "react";
import { Helmet } from "react-helmet";
import { pageTabTitle } from "../Services/DateFunc";
import { Field, Form, Formik } from "formik";
import { useNavigate } from "react-router-dom";
import { setToastData } from "../Store/reducers/Toast";
import { AuthLogin } from "../Services/Auth";
import {  PostAxios } from "../Services/RequestService";
import { ConvertErrorArrayToString } from "../Services/Common";

const UserLogin = () => {
	const dispatch = useDispatch();
	const navigate = useNavigate();
	const { showToast, confirmDisplay } = useSelector((state) => state.toast);
	const [showMenu, setShowMenu] = useState(false);
	return (
		<>
			<Helmet>
				<meta charSet="UTF-8" />
				<meta httpEquiv="X-UA-Compatible" content="IE=edge" />
				<meta name="viewport" content="width=device-width, initial-scale=1.0" />
				<title>{pageTabTitle('Account Login')}</title>
			</Helmet>

			<section className={`login-wrapper${showToast || confirmDisplay ? " popup-open" : ""}`}>
				<header>
					{/*  */}
					<div className={"login-header"}>
						<div className={"left-menu"}>
							<ul className={"logo-left"}>
								<li>
									<img src={`${process.env.PUBLIC_URL}/images/bg-logo-white.png`} alt="Burhani Guards Indore" />
									<span className="brand-title">Burhani Guards Indore</span>
								</li>
							</ul>
						</div>
						<div className={"logo-sec"}>
							<div className={`hamburger-box${(showMenu) ? " active" : ""}`} onClick={() => {
								setShowMenu(!showMenu);
							}}>
								<div className="bun top"></div>
								<div className="meat"></div>
								<div className="bun bottom"></div>
							</div>
							<nav className={`menu main-navbar${(showMenu) ? " active" : ""}`}>
								<ul>
									<li><a href={`https://www.bgindore.com/`}>Home</a></li>
								</ul>
							</nav>
						</div>
					</div>
				</header>
				<div className={`main-sec `}>
					<div className="login-page">
						<div className="login-box">
							<div className="form-box">
								<h2>Login</h2>

								<Formik
									initialValues={{ login_its: "", login_password: "" }}
									validate={(values) => {
										const errors = {};
										if (!values.login_its) {
											errors.login_its = "This field is required";
										}
										if (!values.login_password) {
											errors.login_password = "This field is required";
										}
										return errors;
									}}
									onSubmit={(values, { setSubmitting }) => {
										PostAxios(`login`, {
											login_its: values.login_its,
											login_password: values.login_password,
											device_type: 'web',
											api_token: 'web'
										})
											.then(({data}) => {
												if (data?.error === "1") {
													dispatch(
														setToastData({
															title:'Error',
															message: (data.errors)?ConvertErrorArrayToString(data.errors):data.message,//`${data.message} <br /> `,
															isHtml: true,
															type: "error",
															showCloseBtn: true,
														})
													);
													dispatch(setMainLoading(false));
												} else if (data?.status === "1") {
													AuthLogin(data.data.token, dispatch, () => {
														navigate(`/`);
													});
												} else {
													dispatch(
														setToastData({
															title:'Error',
															message: `${data.message}`,
															type: "error",
															showCloseBtn: true,
														})
													);
													dispatch(setMainLoading(false));
												}
											})
											.catch((err) => {
												setSubmitting(false);
												dispatch(
													setToastData({
														message: `${err.message}`,
														isHtml: true,
														type: "error",
														showCloseBtn: true,
													})
												);
												dispatch(setMainLoading(false));
											})
											.finally(() => {
												setSubmitting(false);
											});
									}}
								>
									{({
										values,
										errors,
										touched,
										handleChange,
										handleBlur,
										handleSubmit,
										isSubmitting,
										/* and other goodies */
									}) => (
										<Form onSubmit={handleSubmit} action="" method="post" autoComplete="off">
											<div
												className={`inputBox ${errors.login_its && touched.login_its ? "error-input" : ""
													}`}
											>
												<Field
													type="text"
													placeholder="ITS"
													name="login_its"
													onChange={handleChange}
													onBlur={handleBlur}
													value={values.login_its}
													autoComplete="off"

												/>
												{errors.login_its && touched.login_its && (
													<label>{errors.login_its}</label>
												)}
											</div>
											<div
												className={`inputBox ${errors.login_password && touched.login_password ? "error-input" : ""
													}`}
											>
												<Field type="password"
													name="login_password"
													placeholder="Password"
													onChange={handleChange}
													onBlur={handleBlur}
													value={values.login_password}
													autoComplete="off" />
												{errors.login_password && touched.login_password && (
													<label>{errors.login_password}</label>
												)}
											</div>
											<button
												className="loginButton"
												disabled={isSubmitting}
												type="submit"
											>
												{isSubmitting ? "Loading..." : "Sign in"}
											</button>
										</Form>
									)}
								</Formik>
							</div>
						</div>
					</div>
				</div>
			</section>
		</>
	)
}

export default UserLogin;